import { useIsEasyOfferEnpiEnabled } from '@/src/shared/feature-flag/feature-flag.hooks'
import { MEASURES_BASE_ROUTE, MESSSTELLEN_BASE_ROUTE, TABS } from '@/src/utils/constants'

// EC-5827: single source of truth for where EnPI lives.
// Flag off -> EnPI stays under Maßnahmen. Flag on -> EnPI moves to the last Messstellen tab.
// Every call site should go through `useEnpiBasePath`/`useEnpiPaths` instead of re-assembling these paths,
// so the two states can never drift apart.
export const ENPI_LEGACY_BASE_PATH = `${MEASURES_BASE_ROUTE}/${TABS.measureHub.enpi}`
export const ENPI_MESSSTELLEN_BASE_PATH = `${MESSSTELLEN_BASE_ROUTE}/${TABS.messstellen.enpi}`

export const useEnpiBasePath = (): string => {
  const isEasyOfferEnpiEnabled = useIsEasyOfferEnpiEnabled()
  return isEasyOfferEnpiEnabled ? ENPI_MESSSTELLEN_BASE_PATH : ENPI_LEGACY_BASE_PATH
}

export const useEnpiPaths = () => {
  const base = useEnpiBasePath()
  return {
    base,
    new: `${base}/new`,
    detail: (enpiId: number | string) => `${base}/${enpiId}`,
    edit: (enpiId: number | string) => `${base}/${enpiId}/edit`,
  }
}
